import script from "./header-toolbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./header-toolbar.vue?vue&type=script&setup=true&lang=ts"

import "./header-toolbar.vue?vue&type=style&index=0&id=10708291&lang=scss"

const __exports__ = script;

export default __exports__